import router from '../../router'
import { auth } from '../../firebase'
import { signInWithEmailAndPassword, signOut } from 'firebase/auth'

export default {
    namespaced: true,
    state: {
        user: null
    },
    mutations: {
        SET_USER(state, user) {
            state.user = user
        },
        CLEAR_USER(state) {
            state.user = null
        }
    },
    actions: {
        async login({ commit }, details) {
            const { email, password } = details

            try {
                await signInWithEmailAndPassword(auth, email, password)

            } catch (error) {
                switch (error.code) {
                    case 'auth/user-not-found':
                        alert("User not found")
                        break
                    case 'auth/wrong-password':
                        alert("Wrong password")
                        break
                    default:
                        alert("Incorrect email/password")
                }
                return
            }

            commit('SET_USER', auth.currentUser)
            router.push('/events')
        },
        async logout({ commit }) {
            await signOut(auth)

            commit('CLEAR_USER')
            router.push('/login')
        },
        async fetchUser({ commit }) {
            return new Promise((resolve) => {
                auth.onAuthStateChanged(async (user) => {
                    if (user === null) {
                        commit('CLEAR_USER');
                    } else {
                        commit('SET_USER', user);
                    }
                    resolve();
                });
            });
        }
    },
    getters: {
        user: state => state.user
    }
}